import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import "./toaster.scss";
import { Button } from "@mui/material";
import ActionButton from "./ActionButton";

let toasterConfirmBoolean: boolean = false;
const toastOptions: any = (state: any) => {
  let obj: any;
  obj = {
    position: "top-right",
  };
  if (state === "success") {
    obj.className = "toaster-success";
  } else if (state === "error") {
    obj.className = "toaster-error";
  } else if (state === "warning") {
    obj.className = "toaster-warning";
  }
  return obj;
};

const Toaster = {
  success: (title: string = "Success!", message: string = "Action success") => {
    template(title, message, "success");
  },
  error: (
    title: string = "Error!",
    message: string = "Something went wrong"
  ) => {
    template(title, message, "error");
  },
  warning: (
    title: string = "Warning!",
    message: string = "Something went wrong",
    callback: any,
    actionButtons?: boolean,
    names?: any
  ) => {
    toasterConfirmBoolean = false;
    template(title, message, "warning", actionButtons, names);
    setTimeout(() => {
      callback(toasterConfirmBoolean);
    }, 4500);
  },
  normal: (title: string, message: string) => {
    template(title, message, "normal");
  },
};
const dismissToaster = (toaster: any, t: any) => {
  toast.remove(t.id);
  toaster.dismiss(t.id);
};

const template = (
  title: string,
  message: string,
  state: string,
  actionButtons?: boolean,
  names?: any
) => {
  toast(
    (t) => (
      <div className="toaster">
        <div className="flex justify-content-between padding-down-15">
          <div className="font-18 bolder">{title}</div>
          <div className="pointer" onClick={() => dismissToaster(toast, t)}>
            <CloseIcon className="close-icon" />
          </div>
        </div>
        <div>
          <div className="margin-down-10">{message}</div>
          <div className="name-container">
            {names &&
              names?.map((item: any) => {
                return <span>{item}</span>;
              })}
          </div>
        </div>
        {actionButtons && (
          <div className="flex center-end">
            <div className="margin-right-20">
              <Button
                className="clear-btn2 "
                onClick={() => dismissToaster(toast, t)}
              >
                No
              </Button>
            </div>
            <ActionButton
              label="Yes"
              actionButtonStyle="dark"
              onClick={() => {
                toasterConfirmBoolean = true;
                dismissToaster(toast, t);
              }}
            />
          </div>
        )}
      </div>
    ),
    toastOptions(state)
  );
};

export default Toaster;
